import React , { useState  } from 'react';
import DepositModal from './DepositModal';
import Button from "react-bootstrap/Button";
import cn from "classnames";
import style from "./style.module.scss"
import {t} from "i18next";

const DepositInvoice = () => {

    const [isOpen, setIsOpen] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
    }
    const openModal = () => {
        setIsOpen(true);
    }

    return (
        <div>
            <button  className={cn(style.btn, "ms-auto")} onClick={openModal}>{t('balanceList.invoiceForPaymentButton')}</button>
            {isOpen && <DepositModal onClose={handleClose} /> }
        </div>
    );
};

export default DepositInvoice;